import ModalAddRiskRelated from './ModalAddRiskRelated';

export default ModalAddRiskRelated;
